export default __webpack_public_path__ + "static/media/selena-dialo.d325c0d6.jpg";